<script lang="ts">

    import type {IDataVehicle} from "../data";
    import {createEventDispatcher, onMount} from "svelte";
    import {Cart, getCart} from "../models/cart";
    import {getCookie, getFormatter} from "../utils";
    import LinearProgress from "@smui/linear-progress";
    import Dialog, {Actions, Content} from "@smui/dialog";
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import ListCart from "./cart/ListCart.svelte";
    import {ManagerVehicles} from "../models/manager-vehicles";

    let formatter = getFormatter();

    export let params;
    export let parent: number;
    export let cart: Cart;
    let dialog = {
        open: false,
        action: '',
        message: ''
    };
    export let loading = false;
    export let vehicle: IDataVehicle;

    const dispatch = createEventDispatcher();

    onMount(() => {
        getCart().then(r => {
            cart = r;
        })
    });

    async function queryByPlaca(params) {
        vehicle = null;
        loading = true;
        try {
            const {query} = params;
            const url = new URL('/backend/servicio/datos-vehiculo/', window.origin);
            url.search = new URLSearchParams(query).toString()
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (response.ok) {
                const data = await response.json();
                setVehicle(data);
            } else {
                throw new Error();
            }
        } catch (e) {
        }
        loading = false;
    }

    function setVehicle(_) {
        vehicle = _;
    }

    async function confirm() {
        loading = true;
        try {
            const response = await fetch(`${window.origin}/compartir-carrito/${parent}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                }
            });
            if (response.ok) {
                const data: any = await response.json();
                cart = new Cart();
                cart.setup(data.cart);
                cart.cartId = data.cart.id;
                const notAvailable = await cart.updateVehicle(vehicle);
                const manager = ManagerVehicles.getInstance();
                manager.addVehicle({
                    ...vehicle
                });
                loading = false;
                dialog = {
                    open: true,
                    action: 'checkout',
                    message: 'Vehiculo validado con éxito'
                };

            } else {
                throw new Error();
            }
        } catch (e) {
            console.error(e);
            loading = false;
            dialog = {
                open: true,
                action: 'error',
                message: 'Se ha presentado un error validando el vehiculo'
            };
        }
    }

    function closeDialog() {
        dialog.open = false
        switch (dialog.action) {
            case 'checkout':
                dispatch('checkout')
                break;
            case 'error':
                break;
        }
        dialog = {
            open: false,
            message: '',
            action: ''
        };
    }

    async function next() {
        loading = true;
        try {
            const response = await fetch(`${window.origin}/compartir-carrito/${parent}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRFToken': getCookie('csrftoken')
                }
            });
            if (response.ok) {
                const data: any = await response.json();
                cart = new Cart();
                cart.setup(data.cart);
                cart.cartId = data.cart.id;
                dispatch('checkout')
            } else {
                throw new Error();
            }
        } catch (e) {
            loading = false;
            dialog = {
                open: true,
                action: 'error',
                message: 'Se ha presentado un error validando el vehiculo'
            };
        }
    }
</script>
<section class="pb-3 max-w-900px mx-auto">
    <div class="container">
        {#if !loading}
            {#if cart}
                <ListCart {cart}/>
                <div class="box my-15">
                    <div class="btn accent min-w-200px text-c"
                         on:click={()=>next()}>
                        Continuar
                    </div>
                </div>
            {/if}
        {:else}
            <div class="text-c loading-bar">
                <LinearProgress class="w-100" indeterminate/>
                <small>Cargando...</small>
            </div>
        {/if}
    </div>
</section>
<!--
{#if vehicle}
    {#if !loading}
        <div class="bg-gray p-1 mb-1">
            {#if vehicle.placa}
                <b class="mb-ii">Placa</b>
                <p>{vehicle.placa}</p>
            {/if}
            <b class="mb-ii">Modelo</b>
            <p>{vehicle.descModeloTASA}</p>
            <p>{vehicle.descModelo}</p>
        </div>
        <div class="box-b sx-ii">
            <button class="btn min-w-200px text-c disabled"
                    on:click={()=>vehicle=null}>
                CANCELAR
            </button>
            <button class="btn accent min-w-200px text-c"
                    on:click={()=>confirm()}>
                CONFIRMAR VEHICULO
            </button>
        </div>
    {:else}
        <div class="text-c loading-bar">
            <LinearProgress class="w-100" indeterminate/>
            <small>Confirmando Vehiculo...</small>
        </div>
    {/if}
{:else}
    <FormPlaca {params}
               {loading}
               showCancel={false}
               on:validateVehicle={({detail})=>queryByPlaca(detail)}
               on:vehicle={({detail})=>setVehicle(detail)}/>
{/if}
-->
<Dialog bind:open={dialog.open}
        scrimClickAction=""
        escapeKeyAction=""
        aria-describedby="mandatory-content">
    <Content id="mandatory-content">
        {@html dialog.message}
    </Content>
    <Actions>
        <div class="box sx-ii">
            <NauiButton caption="IR AL CARRITO"
                        color="accent"
                        mode="solid"
                        on:click={()=>closeDialog()}/>
        </div>
    </Actions>
</Dialog>